function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this,max-lines */
import ShowIf from "../../App/ShowIf";
import { filterOptions } from "../../../shared/optionsUtils";
import { t, Translate } from "../../I18N";

import { Icon as CustomIcon } from "../../Layout/Icon";
import React, { Component, createRef } from 'react';
import { Icon } from "../../UI";var


SelectStates = /*#__PURE__*/function (SelectStates) {SelectStates[SelectStates["OFF"] = 0] = "OFF";SelectStates[SelectStates["PARTIAL"] = 1] = "PARTIAL";SelectStates[SelectStates["ON"] = 2] = "ON";SelectStates[SelectStates["GROUP"] = 3] = "GROUP";return SelectStates;}(SelectStates || {});






























const defaultProps = {
  optionsLabel: 'label',
  optionsValue: 'value',
  prefix: '',
  className: '',
  options: [],
  filter: '',
  optionsToShow: 5,
  showAll: false,
  hideSearch: false,
  showSearch: false,
  sort: false,
  sortbyLabel: false,
  forceHoist: false,
  placeholder: '',
  onChange: (_v) => {},
  onFilter: async (_searchTerm) => {},
  totalPossibleOptions: 0,
  allowSelectGroup: false,
  topLevelSelectable: true
};








const isNotAnEmptyGroup = (option) => !option.options || option.options.length;

class MultiSelectBase extends Component


{




  constructor(props) {
    super(props);_defineProperty(this, "searchInputRef", void 0);
    this.state = { showAll: props.showAll, ui: {}, filter: '', serverSideRender: true };
    this.filter = this.filter.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.showAll = this.showAll.bind(this);
    this.focusSearch = this.focusSearch.bind(this);
    this.searchInputRef = /*#__PURE__*/createRef();
  }

  componentDidMount() {
    this.setState({ serverSideRender: false });
  }

  static getDerivedStateFromProps(props) {
    if (props.filter) {
      return { filter: props.filter };
    }

    return null;
  }

  getPartialList() {
    return [];
  }

  getPinnedList() {
    return [];
  }







  getStateValue(
  value,
  group,
  {
    markGroup,
    conditionValue,
    markOptions




  })
  {
    let newValue = markGroup(value, group);
    group.options.forEach((_item) => {
      if (this.checked(_item) !== conditionValue) {
        newValue = markOptions(newValue, _item);
      }
    });

    return newValue;
  }

  getGroupStateValue(value, group) {
    return this.getStateValue(value, group, {
      markGroup: this.markChecked.bind(this),
      conditionValue: SelectStates.OFF,
      markOptions: this.markUnchecked.bind(this)
    });
  }

  getOnStateValue(value, group) {
    return this.getStateValue(value, group, {
      markGroup: this.markUnchecked.bind(this),
      conditionValue: SelectStates.ON,
      markOptions: this.markChecked.bind(this)
    });
  }

  getOffStateValue(value, group) {
    return this.getStateValue(value, group, {
      markGroup: this.markUnchecked.bind(this),
      conditionValue: SelectStates.OFF,
      markOptions: this.markUnchecked.bind(this)
    });
  }

  changeGroup(group, e) {
    const { value, allowSelectGroup } = this.props;
    const previousState = parseInt(e.target.dataset.state, 10);

    const transitionCallbacks =

    {
      [SelectStates.OFF]: this.getOnStateValue,
      [SelectStates.GROUP]: this.getOffStateValue,
      [SelectStates.PARTIAL]: this.getOffStateValue,
      [SelectStates.ON]: allowSelectGroup ? this.getGroupStateValue : this.getOffStateValue
    };

    this.props.onChange(transitionCallbacks[previousState].call(this, value, group));
  }

  checked(option) {
    if (!this.props.value) {
      return SelectStates.OFF;
    }

    const checkedList = this.getCheckedList();
    const partialList = this.getPartialList();

    if (option.options) {
      if (checkedList.includes(option[this.props.optionsValue])) {
        return SelectStates.GROUP;
      }

      const numChecked = option.options.reduce(
        (nc, _option) => nc + (checkedList.includes(_option[this.props.optionsValue]) ? 1 : 0),
        0
      );
      const numPartial = option.options.reduce(
        (np, _option) => np + (partialList.includes(_option[this.props.optionsValue]) ? 1 : 0),
        0
      );
      if (numChecked === option.options.length) {
        return SelectStates.ON;
      }
      if (numChecked + numPartial > 0) {
        return SelectStates.PARTIAL;
      }
      return SelectStates.OFF;
    }

    if (checkedList.includes(option[this.props.optionsValue])) {
      return SelectStates.ON;
    }

    if (partialList.includes(option[this.props.optionsValue])) {
      return SelectStates.PARTIAL;
    }

    return SelectStates.OFF;
  }

  change(option) {
    let { value } = this.props;
    if (this.checked(option) === SelectStates.ON) {
      value = this.markUnchecked(value, option);
    } else {
      value = this.markChecked(value, option);
    }
    this.props.onChange(value);
  }

  async filter(e) {
    this.setState({ filter: e.target.value });
    await this.props.onFilter(e.target.value);
  }

  async resetFilter() {
    this.setState({ filter: '' });
    await this.props.onFilter('');
  }

  showAll(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showAll: !prevState.showAll }));
  }

  sort(options, isSubGroup = false) {
    const { optionsValue, optionsLabel } = this.props;
    const pinnedList = this.getPinnedList();
    const sortedOptions = options.sort((a, b) => {
      const aPinned = this.checked(a) !== SelectStates.OFF || pinnedList.includes(a[optionsValue]);
      const bPinned = this.checked(b) !== SelectStates.OFF || pinnedList.includes(b[optionsValue]);
      let sorting = 0;
      if (!this.state.showAll) {
        sorting = (bPinned ? 1 : 0) - (aPinned ? 1 : 0);
      }

      if (sorting === 0 && typeof options[0].results !== 'undefined' && a.results !== b.results) {
        sorting = (a.results || 0) > (b.results || 0) ? -1 : 1;
      }

      const showingAll = this.state.showAll || options.length < this.props.optionsToShow;
      if (sorting === 0 || showingAll || this.props.sortbyLabel || isSubGroup) {
        sorting = a[optionsLabel] < b[optionsLabel] ? -1 : 1;
      }

      return sorting;
    });

    return this.moveNoValueOptionToBottom(sortedOptions);
  }

  sortOnlyAggregates(options) {
    const { optionsLabel } = this.props;
    if (!options.length || typeof options[0].results === 'undefined') {
      return options;
    }
    const sortedOptions = options.sort((a, b) => {
      let sorting = (b.results || 0) - (a.results || 0);

      if (sorting === 0) {
        sorting = a[optionsLabel] < b[optionsLabel] ? -1 : 1;
      }

      return sorting;
    });
    return this.moveNoValueOptionToBottom(sortedOptions);
  }

  moveNoValueOptionToBottom(options) {
    let _options = [...options];
    ['any', 'missing'].forEach((bottomId) => {
      const bottomOption = _options.find((opt) => opt.id === bottomId);
      if (bottomOption && this.checked(bottomOption) === SelectStates.OFF) {
        _options = _options.filter((opt) => opt.id !== bottomId);
        _options.push(bottomOption);
      }
    });
    return _options;
  }

  hoistCheckedOptions(options) {
    const [checkedOptions, otherOptions] = options.reduce(
      ([checked, others], option) => {
        if (this.checked(option) !== SelectStates.OFF) {
          return [checked.concat([option]), others];
        }
        return [checked, others.concat([option])];
      },
      [[], []]
    );
    const partitionedOptions = checkedOptions.concat(otherOptions);
    return this.moveNoValueOptionToBottom(partitionedOptions);
  }

  moreLessLabel(totalOptions) {
    const { totalPossibleOptions } = this.props;
    const amount = totalPossibleOptions || totalOptions.length;

    if (this.state.showAll) {
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "x less");
    }

    return (/*#__PURE__*/
      _jsx("span", {}, void 0,
      amount - this.props.optionsToShow, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "x more")
      ));

  }

  toggleOptions(group, e) {
    e.preventDefault();
    const groupKey = group[this.props.optionsValue];
    const { ui } = this.state;
    ui[groupKey] = !ui[groupKey];
    this.setState({ ui });
  }

  showSubOptions(parent) {
    const toggled = this.state.ui[parent.id];
    return toggled || this.checked(parent) !== SelectStates.OFF;
  }

  label(option, isSelect = true) {
    const { optionsValue, optionsLabel, prefix } = this.props;
    const clickEvent = isSelect ? () => {} : this.toggleOptions.bind(this, option);
    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("label", {
        className: "multiselectItem-label multiselectItem-option",
        htmlFor: prefix + option[optionsValue],
        onClick: clickEvent }, void 0, /*#__PURE__*/

      _jsx("span", {
        className: `multiselectItem-icon${
        !isSelect ? ` no-select${this.state.ui[option.id] ? ' expanded' : ''}` : ''}` }, void 0, /*#__PURE__*/


      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" }), /*#__PURE__*/
      _jsx(Icon, { icon: "minus", className: "checkbox-partial" }), /*#__PURE__*/
      _jsx(Icon, { icon: ['fas', 'square'], className: "checkbox-group" }), /*#__PURE__*/
      _jsx(Icon, { icon: "chevron-right", className: "chevron-right" }), /*#__PURE__*/
      _jsx(Icon, { icon: "chevron-down", className: "chevron-down" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name", onClick: clickEvent }, void 0, /*#__PURE__*/
      _jsx(CustomIcon, { className: "item-icon", data: option.icon }),
      option[optionsLabel]
      ), "\xA0"

      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-results" }, void 0,
      option.results && /*#__PURE__*/_jsx("span", {}, void 0, option.results)
      ),
      isSelect && option.options ? /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action", onClick: this.toggleOptions.bind(this, option) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.ui[option.id] ? 'caret-up' : 'caret-down' })
      ) : /*#__PURE__*/

      _jsx("span", { className: "multiselectItem-action placeholder" })

      ));

  }

  focusSearch() {
    const node = this.searchInputRef.current;
    node.focus();
  }

  renderGroup(group, index) {
    const { prefix } = this.props;
    const state = this.checked(group);
    return (/*#__PURE__*/
      _jsx("li", { className: "multiselect-group", "aria-label": "group" }, index, /*#__PURE__*/
      _jsx("div", {
        className: `multiselectItem${
        !this.props.topLevelSelectable ? ' no-top-level-select' : ''}` }, void 0,


      this.props.topLevelSelectable && /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "group-checkbox multiselectItem-input",
        id: prefix + group.id,
        onChange: this.changeGroup.bind(this, group),
        checked: state !== SelectStates.OFF,
        "data-state": state }
      ),

      this.label(_objectSpread(_objectSpread({}, group), {}, { results: group.results }), this.props.topLevelSelectable)
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.showSubOptions(group) }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "multiselectChild is-active" }, void 0,
      group.options.map((_item, i) =>
      this.renderOption(_item, i, index.toString(), state === SelectStates.GROUP)
      )
      )
      )
      ));

  }

  renderOption(option, index, groupIndex = '', disabled = false) {
    const { optionsValue, optionsLabel, prefix } = this.props;
    const key = `${groupIndex}${index}`;

    return (/*#__PURE__*/
      _jsx("li", {
        className: "multiselectItem",

        title: option.title ? option.title : option[optionsLabel] }, key, /*#__PURE__*/

      _jsx("input", {
        type: "checkbox",
        className: "multiselectItem-input",
        value: option[optionsValue],
        id: prefix + option[optionsValue],
        onChange: this.change.bind(this, option),
        checked: this.checked(option) !== SelectStates.OFF,
        "data-state": this.checked(option),
        disabled: disabled }
      ),
      this.label(option)
      ));

  }

  renderSearch() {
    const { placeholder, options, optionsToShow, hideSearch, showSearch } = this.props;

    return (/*#__PURE__*/
      _jsx("li", { className: "multiselectActions" }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: options.length > optionsToShow && !hideSearch || showSearch }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.filter ? 'times-circle' : 'search', onClick: this.resetFilter }), /*#__PURE__*/
      React.createElement("input", {
        ref: this.searchInputRef,
        className: "form-control",
        type: "text",
        placeholder: placeholder || t('System', 'Search item', null, false),
        value: this.state.filter,
        onChange: this.filter }
      )
      )
      )
      ));

  }

  renderOptionsCount(totalOptions, renderedOptions) {
    if (this.state.serverSideRender) {
      return;
    }

    const { totalPossibleOptions } = this.props;
    let count = `${totalPossibleOptions - renderedOptions.length}`;
    if (totalPossibleOptions > 1000) {
      count = `${count}+`;
    }

    return (/*#__PURE__*/
      _jsx("li", { className: "multiselectActions" }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: totalOptions.length > this.props.optionsToShow }, void 0, /*#__PURE__*/
      _jsx("button", { onClick: this.showAll, className: "btn btn-xs btn-default", type: "button" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.showAll ? 'caret-up' : 'caret-down' }), "\xA0",

      this.moreLessLabel(totalOptions)
      )
      ),
      totalPossibleOptions > totalOptions.length && this.state.showAll && /*#__PURE__*/
      _jsx("div", { className: "total-options" }, void 0,
      count, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "more options."), ' ', /*#__PURE__*/
      _jsx("button", { onClick: this.focusSearch, type: "button" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Narrow your search")
      )
      )

      ));

  }

  render() {
    const { optionsLabel, className } = this.props;

    let totalOptions = this.props.options.filter((option) => {
      let notDefined;
      return (
        isNotAnEmptyGroup(option) && (
        option.results === notDefined ||
        option.results > 0 ||
        option.options && option.options.length ||
        this.checked(option)));

    });

    totalOptions = totalOptions.map((option) => {
      if (!option.options) {
        return option;
      }
      return _objectSpread(_objectSpread({},
      option), {}, {
        options: option.options.filter((_opt) => {
          let notDefined;

          return _opt.results === notDefined || _opt.results > 0 || this.checked(_opt);
        }) });

    });

    if (this.state.filter) {
      totalOptions = filterOptions(this.state.filter, totalOptions, optionsLabel);
    }

    let options = totalOptions.slice();

    const tooManyOptions =
    !this.state.showAll &&
    options.length > this.props.optionsToShow &&
    !this.state.serverSideRender;

    if (this.props.sort) {
      options = this.sort(options);
    } else {
      options = this.sortOnlyAggregates(options);
    }

    if (this.props.forceHoist || !this.props.sort && !this.state.showAll) {
      options = this.hoistCheckedOptions(options);
    }

    let renderingOptions = options;

    if (tooManyOptions) {
      const numberOfActiveOptions = options.filter((opt) => this.checked(opt)).length;
      const optionsToShow =
      this.props.optionsToShow > numberOfActiveOptions ?
      this.props.optionsToShow :
      numberOfActiveOptions;
      renderingOptions = options.slice(0, optionsToShow);
    }

    renderingOptions = renderingOptions.map((option) => {
      if (!option.options) {
        return option;
      }
      return _objectSpread(_objectSpread({}, option), {}, { options: this.sort(option.options, true) });
    });

    return (/*#__PURE__*/
      _jsx("ul", { className: `multiselect is-active ${className}` }, void 0,
      this.renderSearch(),
      !renderingOptions.length && /*#__PURE__*/
      _jsx("span", { className: "no-options-message" }, void 0, t('System', 'No options found')),

      renderingOptions.map((option, index) => {
        if (option.options) {
          return this.renderGroup(option, index);
        }

        return this.renderOption(option, index);
      }),
      this.renderOptionsCount(options, renderingOptions)
      ));

  }
}_defineProperty(MultiSelectBase, "defaultProps", defaultProps);

class MultiSelect extends MultiSelectBase {


  markChecked(value, option) {
    const newValue = value.slice(0);
    newValue.push(option[this.props.optionsValue]);
    return newValue;
  }

  markUnchecked(value, option) {
    const opt = option[this.props.optionsValue];
    if (!value.includes(opt)) {
      return value;
    }
    return value.filter((v) => v !== opt);
  }

  getCheckedList() {
    return this.props.value || [];
  }
}_defineProperty(MultiSelect, "defaultProps", _objectSpread(_objectSpread({}, defaultProps), {}, { value: [] }));

class MultiSelectTristate extends MultiSelectBase {


  markChecked(value, option) {
    const opt = option[this.props.optionsValue];
    const newValue = _objectSpread(_objectSpread({}, value), {}, { added: value.added.slice(0), removed: value.removed.slice(0) });
    newValue.removed = value.removed.filter((v) => v !== opt);
    if (value.originalFull.includes(opt)) {
      return newValue;
    }
    // Flip originally partial options from off to partial, and then from partial to on.
    if (!value.originalPartial.includes(opt) || !value.removed.includes(opt)) {
      newValue.added.push(opt);
    }
    return newValue;
  }

  markUnchecked(value, option) {
    const opt = option[this.props.optionsValue];
    const newValue = _objectSpread(_objectSpread({}, value), {}, { added: value.added.slice(0), removed: value.removed.slice(0) });
    if (value.originalFull.includes(opt) || value.originalPartial.includes(opt)) {
      newValue.removed.push(option[this.props.optionsValue]);
    }
    newValue.added = value.added.filter((v) => v !== option[this.props.optionsValue]);
    return newValue;
  }

  getCheckedList() {
    const { value } = this.props;
    return value.originalFull.filter((v) => !value.removed.includes(v)).concat(value.added);
  }

  getPartialList() {
    const { value } = this.props;
    return value.originalPartial.filter((v) => !value.removed.includes(v));
  }

  getPinnedList() {
    const { value } = this.props;
    return value.originalPartial.concat(value.originalFull);
  }
}_defineProperty(MultiSelectTristate, "defaultProps", _objectSpread(_objectSpread({}, defaultProps), {}, { value: {} }));


export { defaultProps, MultiSelect, MultiSelectTristate };